<template>
  <v-layout align-center>
      <v-avatar
      size="48">
        <img class="pa-1" src="@/assets/img/illustrations/cream.png" alt="waste">
      </v-avatar>
      <div style="flex: 1;">
        <v-layout align-center>
          <span>Location: </span>&nbsp;
          <!-- <span>{{ item.location }}</span> -->
          <span>Main store</span>
        </v-layout>
        <v-layout>
          <c-metric-selector
          :inventoryItemID="item.inventory_item_id" 
          :realValue="item.quantity"
          labelMode
          alwaysScale
          ></c-metric-selector>
        </v-layout>
      </div>
      <v-btn icon @click.stop="$emit('editQuantity')">
        <v-icon>
          mdi-pencil-outline
        </v-icon>
      </v-btn>
  </v-layout>
</template>

<script>
export default {
  props: ['item']
}
</script>

